import { Container, Typography } from '@mui/material';

interface ErrorPageProps {
  statusCode?: number;
  message?: string;
}

export default function ErrorPage({ statusCode = 404, message = 'Ops.. Alguma coisa deu errado' }: ErrorPageProps) {
  return (
    <Container
      maxWidth="xl"
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexDirection: 'column',
        height: '100vh',
        gap: 2,
        padding: 3
      }}
    >
      <Typography variant="h1" sx={{ fontSize: '88px', fontWeight: 'bold', color: 'error.main' }}>
        {statusCode}
      </Typography>

      <Typography variant="h6" sx={{ textAlign: 'center', maxWidth: '600px', color: 'text.secondary' }}>
        {message}
      </Typography>
    </Container>
  );
}
